import { TerminalPOSService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const TerminalPOSManager = (() => {
    const { handleException } = ResponseExceptionHandlerHelper();
    const buscarPorId = (Id, esLookup, requestTracker) => {
        return TerminalPOSService.buscarPorId(Id, esLookup, requestTracker).then(
            (res) => {
                if (!res.Success) {
                    handleException(res);
                }
                return res.Data;
            }
        );
    };

    const listado = (where) => {
        return TerminalPOSService.listado(where).then((res) => {
            if (!res.Success) {
                handleException(res);
            }
            return res;
        });
    };

    const crear = (terminal) => {
        return TerminalPOSService.crear(terminal).then((res) => {
            if (!res.Success) {
                handleException(res);
            }
            return res.Data;
        });
    };

    const actualizar = (terminal) => {
        return TerminalPOSService.actualizar({
            ...terminal,
            Files: terminal.Img,
        }).then((res) => {
            if (!res.Success) {
                handleException(res);
            }
            return res.Data;
        });
    };

    return {
        buscarPorId,
        listado,
        crear,
        actualizar,
    };
})();
